// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2tHa8GX4qcDeJmP0WgiVXK","table_head":"qzVeOjc80bWzbMgWwQfqu","table_name":"_1vTp_saRk8hE8heVXaqgAF","table_total":"_22XcBMt8cFWxX1OGTrRSaD","table_head_name":"nr4c6NnD_dQgVBC_3LvsF","sell":"_1nTyVlCc-qrwrytFlYxNpe","sell_price":"_2Bm1ZQ_wgESL9zXZaZ4Vtb","itemList":"_12gGzU--uOg-NMDvliJ0QQ","corridorList":"_2v_ukch_W40ceNuLlr78nB","itemList_noScroll":"OpXbC0ppsj7whb167FFQA","delBtn":"V8R1flPmGokBjBGnUnrDt","symbol":"_35tQD7OGLByvh0T3hTpVD0","itemInfo":"hRknezOgpZOgkklYKvtl7"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/Table.styl
// module id = 748
// module chunks = 0